import { useTranslation } from "react-i18next";
import Modal, { SimpleModalControls } from "../../components/Modal";
import { BillRendered } from "./Bills";
import { Divider, Input, Text } from "@chakra-ui/react";
import { TransactionType } from "../../utils/types.global";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getAxiosInstance } from "../../utils/axiosInstance";

interface EditBillModal extends SimpleModalControls {
    data?: BillRendered
}

type EditTransaction = {
    id: string;
    quantity: number;
    price: number;
    productName: string;
    um: string;
}

const EditBillModal = (props: EditBillModal) => {
    const { t } = useTranslation("translations");
    const {
        isOpen,
        onClose,
        data
    } = props;

    const [editedData, setEditedData] = useState<EditTransaction[]>([]);

    const update = async () => {
        if(!data) return;

        try {
            await getAxiosInstance().put(`/Bill/${data.id}`, {
                    transactions: editedData.map((x) => ({
                        id: x.id,
                        quantity: x.quantity,
                        price: x.price
                    }))
            });
            toast.success(t('BILL_UPDATE_SUCCESSFULLY'), { position: "bottom-right" });
            onClose();
        } catch (e) {
            toast.error(t("SOMETHING_WENT_WRONG"), { position: "bottom-right" });
        }
    }
    
    useEffect(() => {
        if(!data) return;

        const t: EditTransaction[] = [];
        for(const c of data.transactions as any[]) {
            t.push({
                id: c.id, 
                quantity: c.quantity,
                price: c.price,
                productName: c.productName,
                um: c.um
            })
        }
        setEditedData(t);
    }, [data]);

    return (
        <Modal
            header={t("EDIT_BILL_TRANSACTIONS")}
            isOpen={isOpen}
            onClose={onClose}
            size={'4xl'}
            secondaryAction={() => update()}
            secondaryActionName={t("SAVE")}
            secondaryActionEnabled={true}
        >
            <div className="flex flex-row m-4">
                <Text fontSize='md' as="b" className="mr-2">{t("BILL_TYPE")}:</Text>
                {/*@ts-ignore*/}
                <Text> {props.data?.transactions.length > 0 ? t(TransactionType[props.data?.transactions[0].type]) : "-"} </Text>
            </div>
            <div className="flex flex-row m-4">
                <Text fontSize='md' as="b" className="mr-2">{t("NO")}:</Text>
                <Text> {props.data?.billNo} </Text>
            </div>
            <div className="flex flex-row m-4">
                <Text fontSize='md' as="b" className="mr-2"> {t("COMPANY_NAME")}:</Text>
                <Text> {props.data?.companyName} </Text>
            </div>

            <div className="flex flex-row m-4">
                <Text fontSize='md' as="b" className="mr-2"> {t("PLACE_OF_BUSINESS")}:</Text>
                <Text> {props.data?.placeOffBusinessName} </Text>
            </div>
            <div className="flex flex-row m-4">
                <Text fontSize='md' as="b" className="mr-2">{t("BILL_DATE")}:</Text>
                <Text> {props.data?.billDate} </Text>
            </div>
            <div className="flex flex-row m-4">
                <Text fontSize='md' as="b" className="mr-2"> {t("CREATED_AT")}:</Text>
                <Text> {props.data?.createdAt} </Text>
            </div>

            <>
                {
                    props.data?.billAditionalDetails &&
                    <>
                        <Divider className="m-2" />
                        <Text fontSize='xl' as="b" className="m-4">{t("BUYER_DETAILS")}</Text>
                        <div className="flex flex-row m-4">
                            <Text fontSize='md' as="b" className="mr-2"> {t("BILL_BUYER_NAME")}:</Text>
                            <Text> {props.data?.billAditionalDetails.buyerName} </Text>
                        </div>
                        <div className="flex flex-row m-4">
                            <Text fontSize='md' as="b" className="mr-2"> {t("BILL_BUYER_LOCATION")}:</Text>
                            <Text> {props.data?.billAditionalDetails.buyerLocation} </Text>
                        </div>
                        <div className="flex flex-row m-4">
                            <Text fontSize='md' as="b" className="mr-2"> {t("CUI")}:</Text>
                            <Text> {props.data?.billAditionalDetails.cui} </Text>
                        </div>
                    </>
                }
            </>

            <Divider className="m-2" />
                
            <Text fontSize='xl' as="b" className="my-4">{t("PRODUCT_LIST")}</Text>

            <div className="flex flex-col my-4">
                <div className="w-full flex flex-row justify-between m-2">
                    <div className="w-[40%] font-bold">{t("PRODUCT_NAME")}</div>
                    <div className="w-[25%] font-bold">{t("QUANTITY")}</div>
                    <div className="w-[25%] font-bold">{t("UNIT_PRICE")}</div>
                </div>
                <Divider className="m-2"/>
                {
                    editedData.map((x, index) => <div key={`tr_${index}`} className="w-full relative flex flex-row justify-between items-center m-2">
                        <div className="w-[40%] font-bold">{x.productName.toUpperCase()}</div>
                        <div className="w-[25%]">
                            <Input
                                isRequired
                                value={x.quantity}
                                onChange={(e) => {
                                    let tmp = [...editedData];
                                    tmp[index].quantity = +e.target.value;
                                    setEditedData(tmp);
                                }}
                            />
                        </div>
                        <div className="w-[25%]">
                            <Input
                                isRequired
                                value={x.price}
                                onChange={(e) => {
                                    let tmp = [...editedData];
                                    tmp[index].price = +e.target.value;
                                    setEditedData(tmp);
                                }}
                            />
                        </div>
                    </div>)
                }
            </div>
        </Modal>
    )
}

export default EditBillModal;